import React from 'react';
// import {
//   IconButton,
//   Dialog,
//   DialogContent,
//   DialogTitle
// } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Modal } from '@ctsu/react-ctsu-ui';
// import Elements from 'ctsutheme/components/atoms';
// import { FasTimes } from 'assets/icons';
// import { RenderElement } from 'components/RenderHelpers';
// import Draggable from 'react-draggable';

// const { Typography } = Elements;

const styles = theme => ({
  dialogPaper: {
    minHeight: '81vh'
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.dark,
    padding: 10
  },
  closeButton: {
    color: 'white',
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(4)
  }
});

const RSSDialog = props => {
  const {
    onClose, show, children, title, modalSize
  } = props;

  return show && (
      <Modal modalTitle={title} onClose={onClose} modalSize={modalSize}>
        {children}
      </Modal>
      
  );
};

export default withStyles(styles)(RSSDialog);
